import { useInterval } from "ahooks";
import { duration } from "common";
import React from "react";
import { useQueryClient } from "react-query";
import { KeepSessionActiveModal } from "./KeepSessionActiveModal";
import { useSeller, useUser } from "@/hooks/useAccount";
import { useAutoLogout } from "@/hooks/useAutoLogout";
import { isXolaAdmin } from "@/models/User";
import { useAccountStore } from "@/stores/accountStore";

// Seller data is cached for 24 h, so an already signed-in user would otherwise never see the admin turn this AutoLogout on.
const SELLER_REFETCH_MS = duration(15, "minutes");

export const AutoLogout = () => {
    const seller = useSeller();
    const user = useUser();
    const hasAPIKeyinHash = useAccountStore((state) => state.hasAPIKeyinHash);
    const queryClient = useQueryClient();
    const preference = seller.preferences?.autoLogout;

    // exact: nested seller queries (guides, apiKeys, reports) don't need this refresh.
    useInterval(async () => queryClient.invalidateQueries(["sellers", seller.id], { exact: true }), SELLER_REFETCH_MS);

    const { warningDeadline, dismissWarning } = useAutoLogout(
        seller.id,
        preference?.enabled ? preference.idleMinutes : null,
        // Only impersonation gets its own clock: an OAuth admin's idle tab would revoke the refresh cookie its other tabs share.
        isXolaAdmin(user) && hasAPIKeyinHash,
    );

    return <KeepSessionActiveModal deadline={warningDeadline} onKeep={dismissWarning} />;
};
